import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { _ } from './app/consts';

import { defineCustomElements } from '@ionic/pwa-elements/loader';

if (environment.production) {
  enableProdMode();
}

runStartupMigration();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => {
    console.error('Bootstrap failed', err);
    renderBootstrapFallback();
  });

defineCustomElements(window);

function runStartupMigration(): void {
  try {
    const done = safeLocalGet(_.MIGRATION_TAG_KEY);
    if (done === _.MIGRATION_TAG) {
      return;
    }

    const keysToClear = [
      _.AUTHSTATE_KEY,
      _.SELECTED_FILTER,
      _.CHAPTERS_KEY,
      _.GEOLOCATION_KEY,
      _.FAVOURITE_CAR_KEY,
      _.SESSION_HISTORY,
      _.LAST_LOGIN_TYPE,
      _.RECENT_SEARCHES,
      _.VERSION_KEY,
    ];

    for (const k of keysToClear) {
      try { localStorage.removeItem(k); } catch (_e) { /* ignore */ }
    }
    try { sessionStorage.clear(); } catch (_e) { /* ignore */ }

    void clearServiceWorkerAndCaches();

    try { localStorage.setItem(_.MIGRATION_TAG_KEY, _.MIGRATION_TAG); } catch (_e) { /* ignore */ }
  } catch (err) {
    console.warn('Startup migration error', err);
  }
}

function safeLocalGet(key: string): string | null {
  try { return localStorage.getItem(key); } catch (_e) { return null; }
}

async function clearServiceWorkerAndCaches(): Promise<void> {
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map(r => r.unregister().catch(() => undefined)));
    }
  } catch (_e) { /* ignore */ }
  try {
    if (typeof caches !== 'undefined') {
      const keys = await caches.keys();
      await Promise.all(keys.map(k => caches.delete(k).catch(() => false)));
    }
  } catch (_e) { /* ignore */ }
}

function renderBootstrapFallback(): void {
  try {
    const root = document.body || document.documentElement;
    if (!root) return;
    const wrap = document.createElement('div');
    wrap.setAttribute('style', 'position:fixed;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:24px;background:#fff;color:#222;font-family:system-ui,-apple-system,Segoe UI,Roboto,sans-serif;z-index:2147483647;text-align:center;');
    wrap.innerHTML = `
      <div style="max-width:480px;">
        <div style="font-size:18px;font-weight:600;margin-bottom:12px;">Si è verificato un errore all'avvio</div>
        <div style="font-size:14px;line-height:1.5;margin-bottom:20px;color:#555;">Tocca il pulsante qui sotto per ripristinare l'app. Non perderai l'account.</div>
        <button id="yf-reset-btn" style="appearance:none;border:none;background:#0a84ff;color:#fff;font-size:15px;font-weight:600;padding:12px 20px;border-radius:8px;cursor:pointer;">Ripristina e riprova</button>
      </div>
    `;
    root.appendChild(wrap);
    const btn = wrap.querySelector('#yf-reset-btn') as HTMLButtonElement | null;
    if (btn) {
      btn.addEventListener('click', async () => {
        btn.disabled = true;
        btn.textContent = 'Ripristino…';
        try { localStorage.clear(); } catch (_e) { /* ignore */ }
        try { sessionStorage.clear(); } catch (_e) { /* ignore */ }
        await clearServiceWorkerAndCaches();
        window.location.reload();
      });
    }
  } catch (e) {
    console.warn('Failed to render bootstrap fallback', e);
  }
}
